
import { BasicButton } from "@goodgamestudios/asset-globals";
import { BasicLayoutManager } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";
import { LanguageDataEvent } from "@goodgamestudios/core";
import { BasicRegisterDialogProperties } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Constants } from "../../../constants/Poker2Constants";
import { SFConstants } from "../../../constants/SFConstants";
import { AvatarCreationEvent } from "../../../event/AvatarCreationEvent";
import { AvatarVO } from "../../../gamevo/AvatarVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2AvatarCreationDialog extends Poker2Dialog {
    public static NAME: string = "Poker2AvatarCreationDialog";

    private currentGender: string;
    private waitForServer: boolean = false;
    private selectedButton: BasicButton;
    private myAvatarIndex: number = 0;
    private randomAvatars: any[] = [];
    private _randomStartAvatarDataCreated: boolean = false;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected applyProperties(): void {
        super.applyProperties();
        this.waitForServer = false;

        this.creationDialog.btn_female.toolTipText = Poker2Model.languageData.getTextById("create_avatar_female");
        this.creationDialog.btn_male.toolTipText = Poker2Model.languageData.getTextById("create_avatar_male");
        this.creationDialog.btn_random.toolTipText = Poker2Model.languageData.getTextById("create_avatar_random");

        this.creationDialog.btn_next.minWidth = 190;
        this.creationDialog.btn_next.label = Poker2Model.languageData.getTextById("generic_btn_continue");

        this.creationDialog.txt_title.text = Poker2Model.languageData.getTextById("login_title");
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.creationDialog.txt_gender, Poker2Model.languageData.getTextById("create_avatar_gender"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.creationDialog.txt_look, Poker2Model.languageData.getTextById("create_avatar_look"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(13, this.creationDialog.btn_login.txt_label, Poker2Model.languageData.getTextById("login_btn_tologin"));
        this.creationDialog.btn_login.visible = !this.env.loginIsKeyBased;

        this.controller.addEventListener("avatarcreationsuccessfull", this.bindFunction(this.onAvaterCreationSuccessfull));

        if (this.env.loginIsKeyBased)
            this.currentGender = this.env.gender;
        else
            this.currentGender = "male";
        //currentAvatarParts = (currentGender == "male") ? maleAvatarParts : femaleAvatarParts;

        if (!this._randomStartAvatarDataCreated) {
            this.generateRandomAvatars();
        }
    }

    protected onFontsLoaded(event: LanguageDataEvent): void {
        this.applyProperties();
    }

    public show(): void {
        super.show();
        this.switchGender((this.currentGender == "male") ? this.creationDialog.btn_male : this.creationDialog.btn_female);
    }

    public hide(): void {
        this.controller.removeEventListener("avatarcreationsuccessfull", this.bindFunction(this.onAvaterCreationSuccessfull));
        super.hide();
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.creationDialog.btn_login:
                this.hide();
                this.layoutManager.state = BasicLayoutManager.STATE_LOGIN;
                break;
            case this.creationDialog.btn_random:
                this.myAvatarIndex = int((this.myAvatarIndex + 2) % this.randomAvatars.length);
                this.updateAvatar();
                break;
            case this.creationDialog.btn_next:
                this.onCreateAvatar();
                break;
            case this.creationDialog.btn_male:
            case this.creationDialog.btn_female:
                this.switchGender(event.target as BasicButton);
                break;
        }
    }

    private generateRandomAvatars(): void {
        this._randomStartAvatarDataCreated = true;

        this.randomAvatars = AvatarHelper.generatePresetAvatars(Poker2Model.itemShop);
        this.myAvatarIndex = int(MathBase.random(0, this.randomAvatars.length - 1));
    }

    private updateAvatar(): void {
        // clear avater elements
        while (this.creationDialog.mc_holder.numChildren > 0) {
            this.creationDialog.mc_holder.removeChildAt(0);
        }

        var mcAvatar: Container = AvatarHelper.drawAvatarByItemArray(this.randomAvatars[this.myAvatarIndex], true);
        var bounds: Rectangle = mcAvatar.getBounds(null);

        var scaleFactor: number = (155 / bounds.width);
        if ((210 / bounds.height) > scaleFactor)
            scaleFactor = (210 / bounds.height);
        mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
        mcAvatar.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        mcAvatar.y = - (bounds.top * scaleFactor);
        
        mcAvatar.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);

        this.creationDialog.mc_holder.addChild(mcAvatar);
    }

    private switchGender(button: BasicButton): void {
        this.currentGender = (button == this.creationDialog.btn_female) ? "female" : "male";
        // grade is female, ungerade male
        if ((this.currentGender == "male" && (this.myAvatarIndex % 2) != 0) ||
            (this.currentGender == "female" && (this.myAvatarIndex % 2) == 0))
            this.myAvatarIndex = int((this.myAvatarIndex + 1) % this.randomAvatars.length);

        this.activateButton(button);
        this.updateAvatar();
    }
    private activateButton(button: BasicButton): void {
        if (this.selectedButton != button) {
            if (this.selectedButton) this.selectedButton.deselected();
            this.selectedButton = button;
            this.selectedButton.selected();
        }
    }
    private onCreateAvatar(): void {
        var avatarParams: string = this.avatarArrayToString(this.randomAvatars[this.myAvatarIndex]);
        var avatarObject: any = { items: avatarParams, gender: this.currentGender };
        var paramsObject: any = { avatar: avatarObject };
        if (this.env.loginIsKeyBased)
            paramsObject.displayName = this.env.displayName.slice(0, this.env.maxUsernameLength);
        BasicModel.smartfoxClient.sendMessage("lca", [JSON.stringify(paramsObject)]);
    }

    private avatarArrayToString(avatarParts: any[]): string {
        var result: string = "";
        if (avatarParts != null) {
            for (let entryList of avatarParts) {
                var voObject: any = entryList;
                if (voObject === undefined) continue;

                if (result.length > 0) result += "#";
                result += voObject.id + "+" + voObject.colorId;
            }
        }
        return result;
    }

    private avatarArrayToDictionary(avatarParts: any[]): Map<any, any> {
        var result: Map<any, any> = new Map<any, any>();
        if (avatarParts != null) {
            for (let entryList of avatarParts) {
                var voObject: any = entryList;
                if (voObject === undefined) continue;
                result.set(voObject.id, voObject);
            }
        }
        return result;
    }

    private onAvaterCreationSuccessfull(event: AvatarCreationEvent): void {
        if (Poker2Model.userData.guestName != "") {
            Poker2Model.avatarData.myAvatar = new AvatarVO();
            Poker2Model.avatarData.myAvatar.avatarWear = this.avatarArrayToDictionary(this.randomAvatars[this.myAvatarIndex]);
            if (this.env.loginIsKeyBased)
                this.layoutManager.showDialog("Poker2RegisterSocialDialog", new BasicRegisterDialogProperties());
            else
                this.layoutManager.showDialog(Poker2RegisterDialog.NAME, new BasicRegisterDialogProperties());
        }
        this.hide();
    }

    protected get creationDialog(): Library.PokerInterface.PokerAvatarCreation {
        return this.disp as Library.PokerInterface.PokerAvatarCreation;
    }
}
import { AvatarHelper } from "../../helper/AvatarHelper";
import { Poker2RegisterDialog } from "./Poker2RegisterDialog";
import { Poker2RegisterSocialDialog } from "./Poker2RegisterSocialDialog";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";
